/*
  Klaviyo-Glücksrad über das Theme öffnen (Formular in Klaviyo auf "Only on a custom trigger").
  Einstellungen: Theme-Einstellungen > Klaviyo Glücksrad (window.sinobWheel, gesetzt in layout/theme.liquid).
  Regeln: nach X Sekunden oder Y % Scrolltiefe (Produktseiten: nach pdpDelay Sekunden oder wenn der Warenkorb-Button
  aus dem Bild gescrollt ist), am Desktop optional beim Verlassen der Seite;
  nie solange Add-to-Cart-Popup, Warenkorb, Schnellkauf oder Sortenauswahl offen sind;
  optional nicht, wenn schon etwas im Warenkorb liegt. Höchstens einmal pro Besuch (sessionStorage):
  wer das Rad ignoriert und weiterklickt, bekommt es nicht auf jeder Seite neu.
  Klaviyo wendet seine Regeln (Gebiet, bekannte Abonnenten, Pause nach dem Schließen) bei "openForm" nicht
  zuverlässig an, deshalb prüft das Skript selbst: nur in den eingestellten Ländern (Shopify.country),
  nicht bei bekannten Klaviyo-Profilen (Cookie __kla_id mit E-Mail/Exchange-ID), nach dem Schließen X Tage
  Pause, nach dem Absenden nie wieder (localStorage, bei Fehlern lieber gar nicht zeigen).
*/
(function () {
  var cfg = window.sinobWheel || {};
  if (!cfg.enabled || !cfg.formId) return;
  // Ausverkaufte Produktseite: Back-in-Stock-Formular soll im Vordergrund stehen
  if (cfg.soldOut) return;
  if (/^\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname)) return;

  var STORE_KEY = 'sinobWheel';
  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return null; }
  }
  function writeStore(data) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  /* Land */
  var countries = (cfg.countries || '').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
  var country = (window.Shopify && Shopify.country || '').toUpperCase();
  if (countries.length && countries.indexOf(country) === -1) return;

  /* schon abgesendet oder kürzlich geschlossen */
  var store = readStore();
  if (store === null) return;
  if (store.submitted) return;
  if (store.closedAt && Date.now() - store.closedAt < (cfg.pauseDays || 7) * 86400000) return;

  /* in diesem Besuch schon gezeigt */
  var SESSION_KEY = 'sinobWheelShown';
  try { if (sessionStorage.getItem(SESSION_KEY)) return; } catch (e) {}

  /* bekanntes Klaviyo-Profil (z. B. über einen Newsletter-Link gekommen) */
  try {
    var klaCookie = document.cookie.split('; ').filter(function (c) { return c.indexOf('__kla_id=') === 0; })[0];
    if (klaCookie) {
      var kla = JSON.parse(atob(decodeURIComponent(klaCookie.split('=')[1])));
      if (kla && (kla.$email || kla.$exchange_id)) return;
    }
  } catch (e) {}

  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.formId !== cfg.formId) return;
    var st = readStore() || {};
    if (d.type === 'submit' || d.type === 'stepSubmit') { st.submitted = true; writeStore(st); }
    else if (d.type === 'close') { st.closedAt = Date.now(); writeStore(st); }
  });

  var done = false;
  var waitingForOverlay = false;

  function visible(el) {
    return !!el && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden';
  }

  /* Kauf-Klick: das Popup/der Warenkorb ist ein paar hundert ms später erst da, so lange als "offen" werten */
  var lastAddIntent = 0;
  var ADD_SELECTOR = 'form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], [data-staffel-add], .compelet_the_fit_box, [onclick*="addproduct"], [onclick*="addAllItems"], .recomm_popup_tier__button';
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(ADD_SELECTOR)) lastAddIntent = Date.now();
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('form[action*="/cart/add"]')) lastAddIntent = Date.now();
  }, true);

  function overlayOpen() {
    if (Date.now() - lastAddIntent < 6000) return true;
    if (visible(document.getElementById('recomm_popup'))) return true;
    if (document.querySelector('cart-drawer[open], quick-buy-drawer[open], quick-buy-popover[open], dialog[open]')) return true;
    var varList = document.querySelector('.variant_list.fit-variant-list');
    if (visible(varList)) return true;
    return false;
  }

  function cartCount() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.item_count || 0; })
      .catch(function () { return 0; });
  }

  function open() {
    done = true;
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', cfg.formId]);
  }

  function attempt() {
    if (done) return;
    if (overlayOpen()) {
      /* Kaufmoment: warten, bis alles zu ist, dann noch ein paar Sekunden Ruhe */
      if (waitingForOverlay) return;
      waitingForOverlay = true;
      var poll = setInterval(function () {
        if (done) { clearInterval(poll); return; }
        if (!overlayOpen()) {
          clearInterval(poll);
          setTimeout(function () { waitingForOverlay = false; attempt(); }, 4000);
        }
      }, 1000);
      return;
    }
    if (!cfg.skipCart) { open(); return; }
    cartCount().then(function (count) {
      if (done) return;
      if (count > 0) { done = true; return; } /* kauft schon: diesmal kein Rad */
      if (overlayOpen()) { attempt(); return; }
      open();
    });
  }

  /* Wer etwas in den Warenkorb legt, bekommt auf dieser Seite kein Rad mehr (cart:refresh nicht nutzen: feuert schon beim Laden) */
  if (cfg.skipCart) {
    document.addEventListener('variant:add', function () { done = true; });
  }

  /* Produktseiten: erst Preis, Sorte und Warenkorb-Button in Ruhe sehen lassen.
     Rad erst nach pdpDelay Sekunden oder wenn der Besucher am Warenkorb-Button vorbeigescrollt ist. */
  if (cfg.isProduct) {
    setTimeout(attempt, (cfg.pdpDelay || 30) * 1000);
    var buyBtn = document.querySelector('.product-info form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [type="submit"]');
    function onPdpScroll() {
      if (!buyBtn) return;
      if (buyBtn.getBoundingClientRect().bottom < 0) {
        window.removeEventListener('scroll', onPdpScroll);
        attempt();
      }
    }
    window.addEventListener('scroll', onPdpScroll, { passive: true });
  } else {
    setTimeout(attempt, (cfg.delay || 6) * 1000);

    var scrollLimit = (cfg.scroll || 45) / 100;
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= scrollLimit) {
        window.removeEventListener('scroll', onScroll);
        attempt();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (cfg.exitIntent && window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) attempt();
    });
  }
})();
